import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Users, BedDouble, MapPin } from "lucide-react";
import { formatPrice } from "@/lib/api";

export const ListingCard = ({ listing, lang }) => {
  const { t } = useTranslation();
  const name = lang === "he" ? listing.name_he : listing.name_en;
  const neigh = lang === "he" ? listing.neighborhood_he : listing.neighborhood_en;
  return (
    <Link
      to={`/listings/${listing.slug || listing.listing_id}`}
      className="card-listing block group animate-fade-up"
      data-testid={`listing-card-${listing.listing_id}`}
    >
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={listing.cover_image}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
          loading="lazy"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center text-[#8C7A6B] text-xs gap-1.5">
          <MapPin className="h-3.5 w-3.5" />
          <span>{neigh}</span>
        </div>
        <h3 className="font-serif text-2xl text-[#2C2A29] mt-2 leading-tight">{name}</h3>
        <div className="flex items-center gap-4 mt-4 text-sm text-[#595450]">
          <span className="inline-flex items-center gap-1.5"><BedDouble className="h-4 w-4" /> {listing.bedrooms} {t("listings.bedrooms")}</span>
          <span className="inline-flex items-center gap-1.5"><Users className="h-4 w-4" /> {t("listings.max_guests", { n: listing.max_guests })}</span>
        </div>
        <div className="flex items-baseline justify-between mt-5 pt-5 border-t border-[#EAE3D9]">
          <div>
            <span className="font-serif text-2xl text-[#2C2A29]">{formatPrice(listing.display_price ?? listing.price_per_night, listing.currency)}</span>
            <span className="text-sm text-[#8C7A6B] ms-1">{listing.display_price_is_avg ? t("listings.avg_per_night") : t("listings.per_night")}</span>
          </div>
          <span className="text-sm text-[#C86D53] group-hover:translate-x-1 transition-transform">{t("cta.view")} →</span>
        </div>
      </div>
    </Link>
  );
};
